<template>
  <div class="px-6 py-28 text-center">
    <UiNarrowContainer class="rounded-xl border border-neutral-200 p-4 md:p-20">
      <UiHeading v-if="content.subtitle" type="h4" class="mb-4 text-primary-400">{{ content.subtitle }}</UiHeading>
      <UiHeading type="h1" class="mb-16">{{ content.title }}</UiHeading>

      <UiSlider id="page-testimonials" show-arrows placement="bottom">
        <PageTestimonial v-for="item of content.testimonials" :key="item.id" :item="item" />
      </UiSlider>
    </UiNarrowContainer>
  </div>
</template>

<script setup lang="ts">
import type { PageTestimonialsProps } from '~/components/Page/types';

defineProps<PageTestimonialsProps>();
</script>
